import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {AXIOS_BASE_URL} from '../../constants';

axios.defaults.baseURL = AXIOS_BASE_URL;

  export const getExercise = createAsyncThunk(
    "exercises/getExercise",
    async (params, thunkAPI) => {
      const searchParams = new URLSearchParams(params);
      try {
        const response = await axios.get(
          `/api/exercises?${searchParams.toString()}`
        );
        return response.data; 
      } 
      catch (error) {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );
  
  export const addHomework = createAsyncThunk(
    "exercises/addHomework",
    async (credentials, thunkAPI) => {
      try {
        const response = await axios.post(
          "/api/exercises/homework/create",
          credentials
        );

        return response.data; 
      } catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );
  
  export const updateHomework = createAsyncThunk(
    "exercises/updateHomework",
    async (credentials, thunkAPI) => {
      try {
        const response = await axios.patch(
          "/api/exercises/homework/edit", credentials
        );

        return response.data; 
      } catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );
  
  export const updateHomeworkRating = createAsyncThunk(
    "exercises/updateHomeworkRating",
    async (credentials, thunkAPI) => {
      try {
        const response = await axios.patch("/api/exercises/homework-rating", credentials);
        return response.data; 
      } 
      catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );

  export const deleteHomework = createAsyncThunk(
    "exercises/deleteHomework",
    async (credentials, thunkAPI) => {
      try {
        const response = await axios.delete(
          "/api/exercises/homework/delete",
          {
            data: credentials,
          }
        );

        return response.data;
      } catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );

  export const addComment = createAsyncThunk(
    "exercises/addComment",
    async (credentials, thunkAPI) => {
      try {
        const response = await axios.post(
          "/api/exercises/comment/create",
          credentials
        );

        return response.data; 
      } catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );

  export const updateComment = createAsyncThunk(
    "exercises/updateComment",
    async (credentials, thunkAPI) => {
      try {
        const response = await axios.patch(
          "/api/exercises/comment/edit",
          credentials
        );

        return response.data; 
      } catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );

  export const updateCommentStatus = createAsyncThunk(
    "exercises/updateCommentStatus",
    async (params, thunkAPI) => {
      const searchParams = new URLSearchParams(params);
      try {
        const response = await axios.patch(
          `/api/exercises/comment-status?${searchParams.toString()}`
        );

        return response.data; 
      } catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );
  
  export const deleteComment = createAsyncThunk(
    "exercises/deleteComment",
    async (credentials, thunkAPI) => {
      try {
        const response = await axios.delete(
          "/api/exercises/comment/delete",
          {
            data: credentials,
          }
        );

        return response.data;
      } catch (error) {
        alert(error.response.data.message);
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );

  export const getNotifications = createAsyncThunk(
    "exercises/getNotifications",
    async (params, thunkAPI) => {
      const searchParams = new URLSearchParams(params);
      try {
        const response = await axios.get(
          `/api/exercises/notifications?${searchParams.toString()}`
        );
        return response.data; 
      } 
      catch (error) {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  );

  export const getExerciseById = createAsyncThunk(
    "exercises/getExerciseById",
    async (exerciseId, thunkAPI) => {
      try {
        const response = await axios.get(`/api/exercises/${exerciseId}`);
        return response.data; 
      } 
      catch (error) {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
);
  